import { WINDOW } from '@sentry/svelte';
import { getDomElement } from '@sentry/utils';
import { build_selector } from './buildSelector.js';

/* eslint-disable no-bitwise */

/**
 * Checks if a request is cached by looking for a script tag with the same selector as the constructed selector of the request.
 *
 * This function is a combination of the cache lookups in sveltekit's internal client-side fetch functions
 * - initial_fetch (used during hydration) https://github.com/sveltejs/kit/blob/1c1ddd5e34fce28e6f89299d6c59162bed087589/packages/kit/src/runtime/client/fetcher.js#L76
 * - subsequent_fetch (used afterwards) https://github.com/sveltejs/kit/blob/1c1ddd5e34fce28e6f89299d6c59162bed087589/packages/kit/src/runtime/client/fetcher.js#L98
 *
 * Parts of this function's logic is taken from SvelteKit source code.
 * These lines are annotated with attribution in comments above them.
 *
 * @param input first fetch param
 * @param init second fetch param
 * @returns true if a cache hit was encountered, false otherwise
 */
function isRequestCached(input, init) {
  // build_selector call copied from https://github.com/sveltejs/kit/blob/1c1ddd5e34fce28e6f89299d6c59162bed087589/packages/kit/src/runtime/client/fetcher.js#L77
  const selector = build_selector(input, init);

  const script = getDomElement(selector);

  if (!script) {
    return false;
  }

  // If the script has a data-ttl attribute, we check if we're still in the TTL window:
  try {
    // ttl retrieval taken from https://github.com/sveltejs/kit/blob/1c1ddd5e34fce28e6f89299d6c59162bed087589/packages/kit/src/runtime/client/fetcher.js#L83-L84
    const ttl = Number(script.getAttribute('data-ttl')) * 1000;

    if (isNaN(ttl)) {
      return false;
    }

    if (ttl) {
      // cache hit determination taken from: https://github.com/sveltejs/kit/blob/1c1ddd5e34fce28e6f89299d6c59162bed087589/packages/kit/src/runtime/client/fetcher.js#L105-L106
      return (
        WINDOW.performance.now() < ttl &&
        ['default', 'force-cache', 'only-if-cached', undefined].includes(init && init.cache)
      );
    }
  } catch (e) {
    return false;
  }

  // Otherwise, we check if the script has a content and return true in that case
  return !!script.textContent;
}

export { isRequestCached };
//# sourceMappingURL=lookUpCache.js.map
